function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-20 -22.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.2,55.8l-6.5-6.4.1-.1a43.774,43.774,0,0,0,9.4-16.6h7.5V27.6H42.9V22.5H37.8v5.1H20v5.1H48.4a38.737,38.737,0,0,1-8.1,13.6,40.474,40.474,0,0,1-5.9-8.5H29.3a45.526,45.526,0,0,0,7.6,11.6L24,62.2l3.6,3.6L40.3,53.1,48.2,61ZM64.5,42.9H59.4L48,73.5h5.1L56,65.9H68l2.9,7.6H76ZM57.9,60.7l4.1-11,4.1,11Z",
  fill: "#333"
}));

var SvgTranslate = function SvgTranslate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 51,
    viewBox: "0 0 56 51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTranslate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/translate.266dd102.svg";
export { ForwardRef as ReactComponent };